/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { PRODUCT } from '@constants/constants';
import { useElementSize } from '@/hooks/useElementSize';
import * as Types from '../../pages/mijn-carel-lurvink/catalogus/stores/types';
import { ColorAttributes } from './ColorAttributes';
import { LabeledAttributes } from './LabeledAttributes';
import styles from './ProductAttributeSelector.module.scss';

interface IProductAttributeSelector {
  selectableVariantAttributes: Types.SelectableVariantAttribute[];
  onAttributeChange: AppCallbackFn;
  attributes: Types.VariantAttributes[];
}

const MAX_HEIGHT = 292;

export const ProductAttributeSelector = ({ selectableVariantAttributes, onAttributeChange, attributes }: IProductAttributeSelector) => {
  const { ref: contentRef, height } = useElementSize();
  const [open, setOpen] = useState(false);
  const showMore = MAX_HEIGHT <= (height + 2);

  return (
    <>
        {selectableVariantAttributes.map((attribute, idx) => {
          // to prevent "deadlock" on attributes that do not lead to a valid product variant
          // The first atrributes set is never disabled
          const disableAllowed = idx !== 0;

          if (attribute.type === PRODUCT.VARIANT_TYPE_COLOR) {
            return (
              <ColorAttributes
                onAttributeChange={onAttributeChange}
                attribute={attribute}
                attributes={attributes}
                key={attribute.type}
                disableAllowed={disableAllowed}
              />
            );
          }

          return (
            <div
              id="collapse-variants"
              className={`${styles.collapse} ${open ? styles.collapseOpen : ''}`}
              style={{
                maxHeight: !open ? MAX_HEIGHT : 1500
              }}
              ref={contentRef}
              key={attribute.type}
            >
            <LabeledAttributes
              onAttributeChange={onAttributeChange}
              attribute={attribute}
              attributes={attributes}
              disableAllowed={disableAllowed}
            />
            </div>
          );
        })}

      {showMore && (
        <div className={styles.collapseToggle}>
          <Button onClick={() => setOpen(!open)} className={styles.collapseButton} variant="outline-primary">
            {open && 'Toon minder'}
            {!open && 'Toon meer'}
          </Button>
        </div>
      )}
    </>
  );
};
